var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.localProperties.behavior ? _vm.localProperties.behavior : '',style:(_vm.imageStyle),attrs:{"draggable":"false","src":_vm.src,"alt":"Image"}})}
var staticRenderFns = []

export { render, staticRenderFns }